var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{attrs:{"text":_vm.$t('interface.aiGeneratedTooltip')}},[_c('div',{staticClass:"ai-generated-message-label"},[_c('icon-ai-generated',{attrs:{"size":10}}),_c('span',[_vm._v(_vm._s(_vm.$t('interface.aiGeneratedLabel')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }